// extracted by mini-css-extract-plugin
export default {"bold":"PileCptSummary_bold__KuZxb","row":"PileCptSummary_row__j0rv8","table":"PileCptSummary_table__2x0k3","min120":"PileCptSummary_min120__vZel4"};